export const SET_MODAL = (state, { isOpen, requiredPlan, allowClose }) => {
	state.isOpen = isOpen;
	state.requiredPlan = requiredPlan;
	state.allowClose = allowClose;
};
